import { getApps, initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics, isSupported } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY?.trim() || '',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN?.trim() || '',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID?.trim() || '',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET?.trim() || '',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID?.trim() || '',
  appId: process.env.REACT_APP_FIREBASE_APP_ID?.trim() || '',
  ...(process.env.REACT_APP_FIREBASE_DATABASE_URL?.trim()
    ? { databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL.trim() }
    : {}),
  ...(process.env.REACT_APP_FIREBASE_MEASUREMENT_ID?.trim()
    ? { measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID.trim() }
    : {}),
};

const requiredConfig = {
  apiKey: 'REACT_APP_FIREBASE_API_KEY',
  authDomain: 'REACT_APP_FIREBASE_AUTH_DOMAIN',
  projectId: 'REACT_APP_FIREBASE_PROJECT_ID',
  storageBucket: 'REACT_APP_FIREBASE_STORAGE_BUCKET',
  messagingSenderId: 'REACT_APP_FIREBASE_MESSAGING_SENDER_ID',
  appId: 'REACT_APP_FIREBASE_APP_ID',
};
const missingConfig = Object.entries(requiredConfig)
  .filter(([field]) => {
    const value = firebaseConfig[field];
    return !value || /^(your[-_ ]|changeme|change[-_ ]me|placeholder|<)/i.test(value);
  })
  .map(([, envName]) => envName);
const existingApp = getApps().find((firebaseApp) => firebaseApp.name === '[DEFAULT]');
const appConfigMismatch = existingApp && (
  existingApp.options.projectId !== firebaseConfig.projectId
  || existingApp.options.authDomain !== firebaseConfig.authDomain
  || existingApp.options.appId !== firebaseConfig.appId
);

const firebaseSetupInstructions = process.env.NODE_ENV === 'development'
  ? 'Add these values to .env.local, copy them from your Firebase Console web app settings, then restart the development server.'
  : 'Set these values in your frontend hosting service build environment, copy them from your Firebase Console web app settings, then trigger a new deployment.';

export const firebaseConfigError = missingConfig.length
  ? `Firebase authentication is not configured. ${firebaseSetupInstructions} Missing: ${missingConfig.join(', ')}.`
  : appConfigMismatch
    ? 'Firebase authentication is already initialized for a different project. Check the REACT_APP_FIREBASE_* settings and restart the development server.'
    : '';

if (firebaseConfigError && process.env.NODE_ENV === 'development') {
  console.error(`[QubeYards] ${firebaseConfigError}`);
}

const app = firebaseConfigError ? null : existingApp || initializeApp(firebaseConfig);
const auth = app ? getAuth(app) : null;
const db = app ? getFirestore(app) : null;
const storage = app ? getStorage(app) : null;
let analytics = null;
if (app && firebaseConfig.measurementId && typeof window !== 'undefined') {
  isSupported().then((supported) => {
    if (supported) analytics = getAnalytics(app);
  }).catch(() => {});
}

export { app, auth, db, storage, analytics };
